import { logPageAccessAPI } from "@/apis/auth-api"
import { authStore } from "@/routes/login/auth-store"
import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"

const getPageName = ({ pathname }) => {
  if (pathname === "/select") return "선택 페이지"
  if (pathname === "/select/apt") return "아파트 선택 페이지"
  if (pathname === "/select/org") return "기관 선택 페이지"

  if (pathname === "/admin") return null
  if (/^\/admin(?:\/|$)/.test(pathname)) return "관리자 페이지"

  if (pathname === "/simulator") return "시뮬레이터 입력 페이지"
  if (pathname === "/simulator/result") return "시뮬레이터 결과 페이지"
  if (/^\/my(?:\/|$)/.test(pathname)) {
    if (pathname === "/my") return "마이 페이지"
    if (pathname === "/my/pw/verify") return "비밀번호 변경 인증 페이지"
    if (pathname === "/my/pw/change") return "비밀번호 변경 페이지"

    return "마이 페이지"
  }

  if (/^\/org\/[^/]+$/.test(pathname)) return "기관 메인 페이지"

  if (/^\/apt\/[^/]+\/[^/]+\/report$/.test(pathname)) return "통계 페이지"

  if (/^\/apt\/[^/]+\/[^/]+\/analysis$/.test(pathname)) return "누수 분석 페이지"

  if (/^\/apt\/[^/]+\/[^/]+\/units$/.test(pathname)) return "세대 조회 페이지"

  if (/^\/apt\/[^/]+\/[^/]+\/monitoring$/.test(pathname)) return "모니터링 페이지"

  if (/^\/apt\/[^/]+\/[^/]+\/overview$/.test(pathname)) return "아파트 메인 페이지"

  return null
}

const RouteLogger = () => {
  const { pathname } = useLocation()
  const { isAuthenticated } = authStore()
  const lastLoggedRef = useRef("")

  useEffect(() => {
    if (!isAuthenticated) return

    const pageName = getPageName({ pathname })
    if (!pageName) return

    if (lastLoggedRef.current === pathname) return
    lastLoggedRef.current = pathname

    logPageAccessAPI({
      page_name: pageName,
      path: pathname
    }).catch(() => {})
  }, [pathname, isAuthenticated])

  return null
}

export default RouteLogger
